import styled from 'styled-components';
import { colors, MediaQuery } from '../../../../theme/style-helpers';

export const GeneralContainer = styled.div`
    display: grid;
    grid-gap: 32px;
    grid-auto-flow: row;

    ${MediaQuery.medium`
        grid-auto-flow: column;
    `}
`;

export const CategoryContainer = styled.div`
    display: grid;
    grid-gap: 32px;
`;

export const ShipmentSummaryContainer = styled(CategoryContainer)`
    grid-template-columns: 1fr;

    ${MediaQuery.xLarge`
        grid-template-columns: 1fr 1fr;
    `}
`;

export const AdditionalMeasurementsContainer = styled(CategoryContainer)`
    grid-auto-flow: row;

    ${MediaQuery.medium`
        grid-auto-flow: column;
    `}
`;

export const ContentBox = styled.div`
    display: grid;
    grid-gap: 16px;
    padding: 16px;
    background-color: ${colors.LIGHT_GREY};

    ${MediaQuery.medium`
        grid-gap: 32px;
        padding: 32px;
    `}
`;

export const AdditionalInfoContentBox = styled(ContentBox)`
    grid-auto-flow: column;

    ${MediaQuery.medium`
        grid-auto-flow: row;
    `}
`;

export const GeneralContentBox = styled.div`
    display: grid;
    width: 100%;
`;

export const ContentBoxGap = styled(GeneralContentBox)`
    grid-gap: 16px;
`;

export const ContentBoxGapAddress = styled(ContentBoxGap)`
    grid-gap: 16px;
`;

export const AccessorialsContentBox = styled(ContentBox)`
    ${ContentBoxGap} {
        grid-gap: 32px;
        display: grid;
        flex-direction: row;
        justify-content: flex-start;
    }
`;

export const ContentBoxTitle = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.01em;
`;

export const ContentBoxSubTitle = styled.div`
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
`;

export const ContentBoxText = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
`;

export const ContentBoxInfoColumn = styled.div`
    display: grid;
    grid-auto-flow: row;
    justify-content: space-between;
    ${MediaQuery.medium`
        grid-auto-flow: column;
    `}
    ${ContentBoxText} {
        ${MediaQuery.medium`
            text-align: right;
        `}
    }
`;

export const ContentBoxInfoRowContainer = styled(GeneralContentBox)`
    grid-auto-flow: row;
    grid-gap: 20px;
    align-items: ${(props) => (props.alignItems ? props.alignItems : 'stretch')};

    ${MediaQuery.large`
        grid-auto-flow: column;
    `}
`;

export const ContentBoxInfoRow = styled.div`
    display: grid;
    grid-auto-flow: row;
    justify-content: space-between;

    ${MediaQuery.medium`
        grid-gap: 10px;
        grid-auto-flow: column;
    `}

    ${MediaQuery.large`
        grid-auto-flow: row;
    `}
`;

export const AccessorialsContentBoxInfoRow = styled(ContentBoxInfoRow)`
    font-size: 1.6rem;
    font-weight: 400;
    align-items: center;

    ${MediaQuery.medium`
        grid-gap: 10px;
        margin-right: 137px;
        grid-row: 1;

        &:last-child {
            margin-right: 0;
        }
        grid-auto-flow: row;
    `}
`;

export const ContentBoxDivider = styled.div`
    display: none;
    width: 100%;
    height: 2px;
    background-color: ${colors.COOL_GREY};

    ${MediaQuery.medium`
        display: unset;
    `}
`;

export const ContentBoxInlineLabel = styled.span`
    font-family: Montserrat;
    font-size: 1.6rem;
    font-weight: bold;
`;

export const ContentBoxInlineValue = styled.span`
    font-family: Montserrat;
    font-size: 1.6rem;
    font-weight: 400;

    &.capitalize{
        text-transform: capitalize;
    }
`;

export const ChargesBoxInfoRow = styled(ContentBoxInfoRow)`
    grid-template-colums: 100%;
    grid-auto-flow: row;
    grid-auto-columns: 100%;
    grid-gap: 0;

    ${MediaQuery.medium`
        grid-gap: 0;
        grid-auto-flow: row;
    `}
`;

export const ChargesResumeLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.8rem;
    border-top: ${(props) => (props.withBorder ? 'solid 1px #aaa' : 'none')};
    padding-top: ${(props) => (props.withBorder ? '16px' : '0')};
`;
